import { Star, StarHalf, StarOutline } from '@mui/icons-material';
import { type SvgIconOwnProps } from '@mui/material/SvgIcon/SvgIcon.js';
import { type ComponentType } from 'react';

const stars: [ComponentType<SvgIconOwnProps>, (voteAverage: number) => boolean][] = [
  [Star, (voteAverage: number) => voteAverage >= 7],
  [StarHalf, (voteAverage: number) => voteAverage < 7 && voteAverage > 3],
  [StarOutline, (voteAverage: number) => voteAverage <= 3],
];

export const getStarIcon = (voteAverage: number) => {
  const [icon] = stars.find(([, comparator]) => comparator(voteAverage)) ?? [];
  return icon ?? Star;
};
